module.exports = __webpack_public_path__ + "static/media/whatsapp.5f38be45.gif";